// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeinnovation_main_container{
    height: 722px;
    background-color: #5CBF14;
    position: relative;
    color: #ffffff;
}


.homecorevalues_heading{
    font-weight: 400;
    font-size: 30px;
    line-height: 45.87px;
    text-align: center;
    padding: 50px 0;
    
}

.homeinnovation_container{
    display: flex;
    justify-content: center;
    padding: 0 50px;
    gap: 40px;
}

.homeinnovation_text_container{
    width: 339px;
}

.homeinnovation_texth3{
    font-weight: 700;
    font-size: 36px;
    line-height: 55px;
}

.homeinnovation_textp{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    width: 339px;
    height: 196px;
}

.homeinnovation_gallery_container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
}

.homeinnovation_gallery1 img{
    border-radius: 20px;
}

/* professionalism styling starts here*/
.homeprofessionalism_main_container{
    height: 722px;
    background-color: #012D01;
    position: relative;
    color: #ffffff;
   
}

.homeprofessionalism_container{
    padding-top: 170px;
    
}

.professionalismcorevalues_heading{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    color: #EAAD11;
    
}

.professionalismbgImg_container{
    position: absolute;
    top: 0;
    right: 0;
    
}

/* responsiveness starts here */

@media screen and (max-width: 1050px){

    .homeinnovation_main_container, .homeprofessionalism_main_container{
        height: 600px;
    }
    
    .homeinnovation_container{
        display: flex;
        justify-content: center;
        padding: 0 50px;
        gap: 30px;
    }
    
    .homeinnovation_text_container{
        width: 280px;
    }
    
    .homeinnovation_texth3{
        font-size: 30px;
    }
    
    .homeinnovation_textp{
        font-size: 16px;
        width: 300px;
    }
    
    .homeinnovation_gallery_container{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }
    
    .homeinnovation_gallery1 img{
        width: 400px;
        /* height: 400px; */
    }

    .homeinnovation_gallery2 img{
        /* width: 300px; */
        height: 260px;
    }

    .homeprofessionalism_container{
        padding-top: 160px;
        
    }


    
}


@media screen and (max-width: 900px){
    
    .homeinnovation_container{
        align-items: center;
        padding: 0 40px;
        gap: 20px;
    }

    .homeinnovation_text_container{
        width: 240px;
    }
    
    .homeinnovation_texth3{
        font-size:28px;
    }
    
    .homeinnovation_textp{
        font-size: 14px;
        width: 240px;
    }
    
    .homeinnovation_gallery_container{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }
    
    .homeinnovation_gallery1 img{
        width: 270px;
        /* height: 400px; */
    }

    .homeinnovation_gallery2 img{
        /* width: 300px; */
        height: 180px;
    }

    .homeprofessionalism_container{
        padding-top: 120px;
        
    }

    
}

@media screen and (max-width: 500px){
    .homeinnovation_main_container, .homeinnovation_main_container{
        height: 650px;
    }
    
    
    .homecorevalues_heading{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        text-align: center;
        padding: 50px 0;
        
    }
    
    .homeinnovation_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 20px;
        gap: 20px;
    }
    
    .homeinnovation_text_container{
        width: 100%;
    }
    
    .homeinnovation_texth3{
        font-weight: 700;
        font-size: 24px;
        line-height: 55px;
    }
    
    .homeinnovation_textp{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        width: 339px;
        height: 196px;
    }
    
    .homeinnovation_gallery_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        /* gap: 15px; */
    }
    
    .homeinnovation_gallery1 img{
        border-radius: 20px;
        width: 100%;
        
    }
    .homeinnovation_gallery2{
        display: none;
    }

    .homeprofessionalism_container{
        padding-top: 90px;
    }

    .professionalism_text_container{
        height: 220px;
    }

    .professionalismcorevalues_heading{
        font-size: 16px ;
        line-height: 24.46px;
        font-weight: 400;
        color: #EAAD11;
    }
    
}

@media screen and (max-width: 380px){

    .homecorevalues_heading{
        font-size: 22px;
        
    }
    
    
    .homeinnovation_texth3{
        font-size: 20px;
    }
    
    .homeinnovation_textp{

        font-size: 15px;
        width:100%;
        height: 196px;
    }
    
    
}


@media screen and (max-width: 330px){

    .homeinnovation_main_container{
        height: 610px;
    }

    .homecorevalues_heading{
        font-size: 20px;
        
    }
    
    .homeinnovation_texth3{
        font-size: 19px;
    }
    
    .homeinnovation_textp{
        font-size: 15px;
        height: 220px;
    }

    .professionalism_text_container{
        height: 260px;
    }
    
    
}`, "",{"version":3,"sources":["webpack://./src/styles/Innovation.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;;AAEZ;;AAEA,+BAA+B;;AAE/B;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,kBAAkB;;IAEtB;;;;AAIJ;;;AAGA;;IAEI;QACI,mBAAmB;QACnB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,kBAAkB;;IAEtB;;;AAGJ;;AAEA;IACI;QACI,aAAa;IACjB;;;IAGA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,eAAe;;IAEnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,WAAW;;IAEf;IACA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;QAChB,cAAc;IAClB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;;IAEnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,UAAU;QACV,aAAa;IACjB;;;AAGJ;;;AAGA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;;AAGJ","sourcesContent":[".homeinnovation_main_container{\n    height: 722px;\n    background-color: #5CBF14;\n    position: relative;\n    color: #ffffff;\n}\n\n\n.homecorevalues_heading{\n    font-weight: 400;\n    font-size: 30px;\n    line-height: 45.87px;\n    text-align: center;\n    padding: 50px 0;\n    \n}\n\n.homeinnovation_container{\n    display: flex;\n    justify-content: center;\n    padding: 0 50px;\n    gap: 40px;\n}\n\n.homeinnovation_text_container{\n    width: 339px;\n}\n\n.homeinnovation_texth3{\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 55px;\n}\n\n.homeinnovation_textp{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    width: 339px;\n    height: 196px;\n}\n\n.homeinnovation_gallery_container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n}\n\n.homeinnovation_gallery1 img{\n    border-radius: 20px;\n}\n\n/* professionalism styling starts here*/\n.homeprofessionalism_main_container{\n    height: 722px;\n    background-color: #012D01;\n    position: relative;\n    color: #ffffff;\n   \n}\n\n.homeprofessionalism_container{\n    padding-top: 170px;\n    \n}\n\n.professionalismcorevalues_heading{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    color: #EAAD11;\n    \n}\n\n.professionalismbgImg_container{\n    position: absolute;\n    top: 0;\n    right: 0;\n    \n}\n\n/* responsiveness starts here */\n\n@media screen and (max-width: 1050px){\n\n    .homeinnovation_main_container, .homeprofessionalism_main_container{\n        height: 600px;\n    }\n    \n    .homeinnovation_container{\n        display: flex;\n        justify-content: center;\n        padding: 0 50px;\n        gap: 30px;\n    }\n    \n    .homeinnovation_text_container{\n        width: 280px;\n    }\n    \n    .homeinnovation_texth3{\n        font-size: 30px;\n    }\n    \n    .homeinnovation_textp{\n        font-size: 16px;\n        width: 300px;\n    }\n    \n    .homeinnovation_gallery_container{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n    }\n    \n    .homeinnovation_gallery1 img{\n        width: 400px;\n        /* height: 400px; */\n    }\n\n    .homeinnovation_gallery2 img{\n        /* width: 300px; */\n        height: 260px;\n    }\n\n    .homeprofessionalism_container{\n        padding-top: 160px;\n        \n    }\n\n\n    \n}\n\n\n@media screen and (max-width: 900px){\n    \n    .homeinnovation_container{\n        align-items: center;\n        padding: 0 40px;\n        gap: 20px;\n    }\n\n    .homeinnovation_text_container{\n        width: 240px;\n    }\n    \n    .homeinnovation_texth3{\n        font-size:28px;\n    }\n    \n    .homeinnovation_textp{\n        font-size: 14px;\n        width: 240px;\n    }\n    \n    .homeinnovation_gallery_container{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n    }\n    \n    .homeinnovation_gallery1 img{\n        width: 270px;\n        /* height: 400px; */\n    }\n\n    .homeinnovation_gallery2 img{\n        /* width: 300px; */\n        height: 180px;\n    }\n\n    .homeprofessionalism_container{\n        padding-top: 120px;\n        \n    }\n\n    \n}\n\n@media screen and (max-width: 500px){\n    .homeinnovation_main_container, .homeinnovation_main_container{\n        height: 650px;\n    }\n    \n    \n    .homecorevalues_heading{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        text-align: center;\n        padding: 50px 0;\n        \n    }\n    \n    .homeinnovation_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding: 0 20px;\n        gap: 20px;\n    }\n    \n    .homeinnovation_text_container{\n        width: 100%;\n    }\n    \n    .homeinnovation_texth3{\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 55px;\n    }\n    \n    .homeinnovation_textp{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        width: 339px;\n        height: 196px;\n    }\n    \n    .homeinnovation_gallery_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        /* gap: 15px; */\n    }\n    \n    .homeinnovation_gallery1 img{\n        border-radius: 20px;\n        width: 100%;\n        \n    }\n    .homeinnovation_gallery2{\n        display: none;\n    }\n\n    .homeprofessionalism_container{\n        padding-top: 90px;\n    }\n\n    .professionalism_text_container{\n        height: 220px;\n    }\n\n    .professionalismcorevalues_heading{\n        font-size: 16px ;\n        line-height: 24.46px;\n        font-weight: 400;\n        color: #EAAD11;\n    }\n    \n}\n\n@media screen and (max-width: 380px){\n\n    .homecorevalues_heading{\n        font-size: 22px;\n        \n    }\n    \n    \n    .homeinnovation_texth3{\n        font-size: 20px;\n    }\n    \n    .homeinnovation_textp{\n\n        font-size: 15px;\n        width:100%;\n        height: 196px;\n    }\n    \n    \n}\n\n\n@media screen and (max-width: 330px){\n\n    .homeinnovation_main_container{\n        height: 610px;\n    }\n\n    .homecorevalues_heading{\n        font-size: 20px;\n        \n    }\n    \n    .homeinnovation_texth3{\n        font-size: 19px;\n    }\n    \n    .homeinnovation_textp{\n        font-size: 15px;\n        height: 220px;\n    }\n\n    .professionalism_text_container{\n        height: 260px;\n    }\n    \n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
